import { CSSProperties, FC } from "react";
import { ActivityIndicator, Image, StyleSheet, View } from "react-native";
import { SLImage } from "./ReactiveImage";

export interface tImagePreviewProps {
  source?: string;
  isRequested: boolean;
  width?: number;
  height?: number;
  key?: string;
}

const ImagePreview: FC<tImagePreviewProps> = ({ source, width, height, isRequested }) => {
  const kImageSource = { uri: source };

  if (source) {
    if (width && height) {
      webStyles.baseStyle.width = width;
      webStyles.baseStyle.height = height;
    } else if (width) {
      Image.getSize(source, (imageWidth, imageHeight) => {
        webStyles.baseStyle.width = width;
        webStyles.baseStyle.height = imageHeight * (width / imageWidth);
      });
    } else if (height) {
      Image.getSize(source, (imageWidth, imageHeight) => {
        webStyles.baseStyle.height = height;
        webStyles.baseStyle.width = imageWidth * (height / imageHeight);
      });
    } else {
      Image.getSize(source, (imageWidth, imageHeight) => {
        webStyles.baseStyle.width = 200;
        webStyles.baseStyle.height = imageHeight * (200 / imageWidth);
      });
    }
  }

  return (
    <View>
      {isRequested && source === undefined ? (
        <ActivityIndicator />
      ) : (
        <SLImage mobileStyle={styles.baseStyle} webStyle={webStyles.baseStyle} source={kImageSource} />
      )}
    </View>
  );
};

export default ImagePreview;

const styles = StyleSheet.create({
  baseStyle: {
    marginRight: 16,
  },
});

const webStyles: { [key: string]: CSSProperties } = {
  baseStyle: {
    marginRight: 16,
  },
} as const;
